import { Pipe, PipeTransform, Inject, LOCALE_ID, InjectionToken, Optional } from '@angular/core';

export const WF_LANG_RESOURCES = new InjectionToken("WF_LANG_RESOURCES");

@Pipe({ name: 'wfLocale' })
export class WfLocalePipe implements PipeTransform {
    private readonly defaultLang: string = "zh-CHS";
    public langCode: string;
    private lang: {};
    private resources;
    constructor(
        @Optional() @Inject(LOCALE_ID) localeId: string,
        @Optional() @Inject(WF_LANG_RESOURCES) resources: any,
    ) {
        this.langCode = localeId || this.defaultLang;
        this.resources = resources || {};
        this.lang = resources[this.langCode] || resources[this.defaultLang] || {};
    }
    transform(name: string): any {
        const keys = name.split(".")
        let temp = this.lang;
        for (let key of keys) {
            temp = temp[key];
            if (temp == null) {
                break;
            }
        }
        return temp || name;
    }

    instant(name: string): any {
        return this.transform(name);
    }
}

